module.exports = __webpack_public_path__ + "img/icon-white.f533ccbf.png";